import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Grid } from 'react-bootstrap';
import OptionButton from '../OptionButton/';

class RootOptionGroup extends Component {
  render() {
    const { options, prompt, selected, onSelect, prefix, namespace, userIdentified, hasEmployer } = this.props;

    const optionButtons = options.map(option => (
      <OptionButton
        key={option.id}
        active={selected === option.id}
        onClick={onSelect}
        option={option}
        prefix={prefix}
        namespace={namespace}
        disabled={userIdentified && !hasEmployer && option.requiresEmployer}
      />
    ));

    return (
      <div className="option-group">
        <FormGroup>
          <Grid fluid>
            {optionButtons}
          </Grid>
        </FormGroup>
      </div>
    );
  }
}

RootOptionGroup.propTypes = {
  prompt: PropTypes.string,
  options: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  onSelect: PropTypes.func.isRequired,
  prefix: PropTypes.string,
  namespace: PropTypes.string,
  userIdentified: PropTypes.bool.isRequired,
  hasEmployer: PropTypes.bool.isRequired
};

RootOptionGroup.defaultProps = {
  prompt: null,
  options: [],
  selected: false,
  prefix: 'pathConfig',
  namespace: '',
  userIdentified: false,
  hasEmployer: false
};

export default RootOptionGroup;



// WEBPACK FOOTER //
// ./src/components/RootOptionGroup/RootOptionGroup.jsx